import config from "../../app.json";
import axios from "axios";
import "./chatlist.scss";

import React, { useState, useEffect, useRef, useContext } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { Container } from "react-bootstrap";
import Image from "../Image/image";
import NewChat from "../../Components/NewChat/newchat";
import AlertComponent from "../../Components/AlertComponent";
import { Context } from "../../Reducers/Store";

import UserAvatar from "../../Assets/Images/avatar-sc.png";
import PlusIcon from "../../Assets/Images/plus.svg";

import moment from "moment";
import "moment-timezone";

function ChatList(props) {
  const [state, dispatch] = useContext(Context);

  const [items, setItems] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [chatId, setChatid] = useState(0);
  const [showCreateChat, setShowCreateChat] = useState(false);
  const [checkboxes, setCheckboxes] = useState([]);
  const [profileId, setProfileId] = useState(null);

  const messagesRef = useRef(null);

  useEffect(() => {
    if (state?.isLogged) {
        dispatch({ type: "SET_LOADING", payload: true });
        axios.get(config.API_HM + "/profile").then((result) => {
        setProfileId(result.data.id);
      }).catch((error) => {
        AlertComponent("Error", error.message ?? "Something went wrong. Profile could not be loaded. Code: 3", { icon: `error` });
      })
      .finally(() => {
        dispatch({ type: "SET_LOADING", payload: false });
      });
    }
  }, [state?.isLogged]);

  const handleCheckboxChange = (item) => {
    if (checkboxes.includes(item)) {
      setCheckboxes(checkboxes.filter((value) => value !== item));
    } else {
      setCheckboxes([...checkboxes, item]);
    }
  };

  const handleDeleteChatlist = () => {
    return AlertComponent(
      "Confirm",
      "Do you really want to delete the chat list? This action cannot be undone.",
      { icon: `warning`, showConfirmButton: true, showCancelButton: true, cancelButtonText: "No" },
      confirmDeleteChat,
      false,
      "Yes"
    );
  };

  const confirmDeleteChat = async () => {
    for (let index = 0; index < checkboxes.length; index++) {
      const selectedChatId = checkboxes[index];
      setCheckboxes(checkboxes.filter((value) => value !== selectedChatId));
      await axios
        .delete(config.API_HM + "/chats/" + selectedChatId)
        .then(() => {
          afterCreateChat();
        })
        .catch(function (error) {
          return AlertComponent("Error", error.message, { icon: `error` });
        });
    }
  };

  const handleShowChat = () => {
    setShowCreateChat(true);
  };

  if (props.chatId && props.chatId !== chatId) {
    setChatid(props.chatId);
  }

  const afterCreateChat = () => {
    fetchChats();
  };

  const fetchChats = async () => {
    await axios
      .get(config.API_HM + "/chats?listId=" + chatId)
      .then((resC) => {
        const sortedData = resC.data.sort((a, b) => b.id - a.id);

        setItems(sortedData);

        if (sortedData.length) {
          handleSelection(sortedData[0], 0);
        }
        
        dispatch({ type: "SET_RELOAD_CHATLIST", payload: true });
      })
      .catch(function (error) {
      });
  };
  useEffect(() => {
    if (chatId > 0) {
      fetchChats();
    } else {
      handleSelection(0, 0);
    }
  }, [chatId]);

  useEffect(() => {
    if (!props.currentItem || props.currentItem === 0) {
      props.setCurrentItem(null);
    }
  }, [props.currentItem]);

  const handleSelection = (currentItem, currentIndex) => {
    setSelectedIndex(currentIndex);
    props.setCurrentItem(currentItem);
  };

  const chatidSelected = chatId > 0;
  return (
    <div style={{ height: "95vh", display: "flex", flexDirection: "column" }}>
      {chatidSelected && (
        <div className="chat-history-header">
          {/* <div className="profile">
            <div className="top-profile">
              <Image src={config.API_HM + "/profile/image/" + profileId} defaultSrc={UserAvatar} radius={20} />
              <div className="active-user"></div>
            </div>
            <Button className="share">Share</Button>
          </div> */}
          <div className="sub-header">
            <div>
              <h6>Chat History</h6>
              {checkboxes && checkboxes.length > 0 ? (
                <div className="counter">
                  {checkboxes.length}/{items.length}
                </div>
              ) : (
                <div className="counter">0/{items.length}</div>
              )}
            </div>
            <div className="delete-button">
              <Button disabled={!checkboxes || !checkboxes.length} className="trash-can" onClick={handleDeleteChatlist}></Button>
            </div>
          </div>
        </div>
      )}

      <Container style={{ flex: 1, overflowY: "auto" }}>
        <NewChat chatListId={chatId} afterCreateChat={afterCreateChat} setShowCreateChat={setShowCreateChat} showCreateChat={showCreateChat} />
        {items.map((x, index) => {
          let message = x.lastMessage?.message;
          const isImageMessage = message?.startsWith("<p>https:") || message?.startsWith("https:");

          if (isImageMessage) {
            if (message.startsWith("<p>")) {
              message = message.replace("<p>", "").replace("</p>", "");
            }
          }

          return (
            <div key={`chatlist_key_${index}`} ref={messagesRef} className={`conversation-list-item ${index === selectedIndex ? `selected` : null}`}>
              <div className="chat-item">
                <div className="checkbox-container">
                  <label className="custom-checkbox">
                    <input
                      type="checkbox"
                      checked={checkboxes.includes(x.id)}
                      onChange={() => handleCheckboxChange(x.id)}
                    />
                    <span></span>
                  </label>
                  </div>
                    <div className="name-container" onClick={() => handleSelection(x, index)}>
                      <h5 className="chat-name">{x.name}</h5>
                      </div>
                    </div>
              <div onClick={() => handleSelection(x, index)}>
                <Row>
                  <Col md={12}>
                    {message && !isImageMessage && (
                      <div
                        className="chat-content"
                        dangerouslySetInnerHTML={{
                          __html: message,
                        }}></div>
                    )}

                    {message && isImageMessage && <Image classNames="chat-content" src={message} width={150} height={150} radius={20} />}
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <div className="meta-chat-info">
                      <div className="user-photo">
                        <Image src={x.lastMessage?.sender ? config.API_HM + "/profile/image/" + x.lastMessage?.sender?.id : null} defaultSrc={UserAvatar} radius={20} width={40} height={40} />
                      </div>
                      {x && x.lastMessage && <div className="generate-time">{moment.utc(x.lastMessage?.when).tz(moment.tz.guess()).format("YYYY-MM-DD HH:mm")}</div>}
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          );
        })}
      </Container>
      <div className="new-chat-block">
        <Button className="new-chat-button" onClick={handleShowChat}>
        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.5 5V19M5.5 12H19.5"  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
          New Chat
        </Button>
      </div>
    </div>
  );
}

export default ChatList;
